export default {
  form: document.querySelector('.header-form'),
  list: document.querySelector('.tasks-list'),
  btnTheme: document.querySelector('.theme-toggle-button'),
};
